//code对象管理器
import Code from './Code';

let codeManagerObj = {};

function register(codeKey) {
    let codeObj = new Code();
    codeManagerObj = {
        ...codeManagerObj,
        [codeKey]: codeObj
    };
}

function unregister(key) {
    delete codeManagerObj[key];
}

function* getCodeList(key, codeInfoList) {
    const codeObj = codeManagerObj[key];
    const result = yield codeObj.getCodeList(codeInfoList);
    return result;
}
function* getSingleCode(key, codeBH) {
    const codeObj = codeManagerObj[key];
    const result = yield codeObj.getSingleCode(codeBH);
    return result;
}
function* getCode(key, codeBH, prefix) {
    const codeObj = codeManagerObj[key];
    const result = yield codeObj.getCode(codeBH, prefix);
    return result;
}

function* wait(codeKey) {
    const codeObj = codeManagerObj[codeKey];
    yield codeObj.wait();
}

function completeOne(codeKey, promiseKey) {
    const codeObj = codeManagerObj[codeKey];
    codeObj.completeOne(promiseKey);
}

function startOne(codeKey, promiseKey) {
    const codeObj = codeManagerObj[codeKey];
    codeObj.startOne(promiseKey);
}

export default { register, unregister, getCodeList, getSingleCode, getCode, wait, startOne, completeOne };
